var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.166626 6.66667C0.166626 4.45753 1.95749 2.66667 4.16663 2.66667H7.19094C7.38033 2.66667 7.55346 2.55967 7.63816 2.39027L7.91198 1.84262C8.47662 0.713341 9.63083 0 10.8934 0H16.1065C17.3691 0 18.5233 0.713341 19.0879 1.84262L19.3618 2.39027C19.4465 2.55967 19.6196 2.66667 19.809 2.66667H22.8333C25.0424 2.66667 26.8333 4.45753 26.8333 6.66667V20C26.8333 22.2091 25.0424 24 22.8333 24H4.16663C1.95749 24 0.166626 22.2091 0.166626 20V6.66667ZM13.5 18.6667C16.4455 18.6667 18.8333 16.2789 18.8333 13.3333C18.8333 10.3878 16.4455 8 13.5 8C10.5544 8 8.16663 10.3878 8.16663 13.3333C8.16663 16.2789 10.5544 18.6667 13.5 18.6667ZM21.5 9.33333C22.2363 9.33333 22.8333 8.73638 22.8333 8C22.8333 7.26362 22.2363 6.66667 21.5 6.66667C20.7636 6.66667 20.1666 7.26362 20.1666 8C20.1666 8.73638 20.7636 9.33333 21.5 9.33333Z",
    fill: "#B0B8C1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCamera);
export default __webpack_public_path__ + "static/media/icon-camera.f4751f64.svg";
export { ForwardRef as ReactComponent };